import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import Chart from "./Chart";

const PerformanceTabs = [
    { value: 'today', label: 'Today' },
    { value: 'this_week', label: 'This Week' },
    { value: 'this_month', label: 'This Month' },
    { value: 'last_month', label: ['Last Month'] },
    { value: 'last3_months', label: ['3 Months'] },
    { value: 'last6_months', label: ['6 Months'] },
    { value: 'last12_months', label: ['12 Months'] }
];

function Performance({data}: any) {
    const [frequency, setFrequency] = useState(PerformanceTabs[0].value);
    const [label, setLabel] = useState('');
    const [auditorPerformance, setAuditorPerformance ] = useState<any>(null);

    function onFrequencyChange(e: any) {
        setFrequency(e.target.value)
    }

    function setCurrentFrequencyData(frequency: string) {
        const _auditorPerformance = (data || {})[frequency];
        if(!_auditorPerformance) {
            setLabel('')
        } else {
            const label = frequency !== 'today' ?
            `${dayjs(_auditorPerformance.start_date).format('DD-MMM-YYYY')} - ${dayjs(_auditorPerformance.end_date).format('DD-MMM-YYYY')}` :
            `${dayjs(_auditorPerformance.start_date).format('DD-MMM-YYYY')}`;
            setLabel(label);
        }
        setAuditorPerformance(_auditorPerformance);
    }

    useEffect(() => {
        if (data) {
            setTimeout(() => {
                setCurrentFrequencyData(frequency);
            }, 200)
        }
    }, [data])

    useEffect(() => {
        if(frequency && data) {
            setCurrentFrequencyData('')
            setTimeout(() => {
                setCurrentFrequencyData(frequency)
            }, 200)
        }
    }, [frequency])

    return (
        <div className="">
            <div className="card-header bg-white border-0 underline text-appprimary fw-semibold fs-5 d-flex align-items-center">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 22V8H7V22H3ZM10 22V2H14V22H10ZM17 22V14H21V22H17Z" fill="#2965AD" />
                </svg>
                <div className="mx-2">Performance</div>
            </div>
            <div className="card-body pt-0">
                <div className="d-flex flex-row">
                    <div className="col-11 mx-auto mt-3">
                        <div className="d-flex flex-row">
                            <div className="col-3 py-2 ps-3">
                                {
                                    PerformanceTabs.map(tab => {
                                        return (
                                            <div className="form-check mb-3" key={tab.value}>
                                                <input className="form-check-input" type="radio" name="frequency" checked={frequency === tab.value}
                                                    id={'frequency' + tab.value} onChange={onFrequencyChange} value={tab.value} />
                                                <label className="form-check-label" htmlFor={'frequency' + tab.value}>{tab.label}</label>
                                            </div>
                                        )
                                    })
                                }

                            </div>
                            <div className="col-1"></div>
                            <div className="col-8">
                                <div className="text-center mt-3 dashboard-date-range-label">
                                    {label && <strong className="text-primary">({label})</strong>}
                                </div>
                                <div className="row m-0">
                                    {auditorPerformance && <Chart data={auditorPerformance} keys={['audited', 'not_audited']} />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Performance;